import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Phone } from "lucide-react";
import { Button } from "../components/ui/button";
import {
  Accordion, AccordionContent, AccordionItem, AccordionTrigger,
} from "../components/ui/accordion";
import { FAQS, SITE } from "../mock";

export default function FAQs() {
  return (
    <div data-testid="faqs-page">
      <div className="bg-[#0A2540] py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 text-center">
          <div className="text-[#39C1D0] font-bold text-sm uppercase tracking-widest mb-3">Help Center</div>
          <h1 className="text-3xl sm:text-5xl font-extrabold text-white tracking-tight">Frequently Asked Questions</h1>
          <p className="mt-5 text-slate-300 max-w-2xl mx-auto">
            Everything you need to know about testing with Modern Business Solutions.
          </p>
        </div>
      </div>

      <section className="py-16 bg-white">
        <div className="max-w-3xl mx-auto px-4 sm:px-6">
          <Accordion type="single" collapsible className="space-y-4">
            {FAQS.map((f, i) => (
              <AccordionItem
                key={i}
                value={`faq-${i}`}
                className="border border-slate-100 rounded-xl px-6 shadow-sm data-[state=open]:shadow-md transition-shadow bg-white"
              >
                <AccordionTrigger className="text-left font-bold text-[#0A2540] hover:text-[#0E9AAA] hover:no-underline py-5">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-slate-600 leading-relaxed pb-5">{f.a}</AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>

          <div className="mt-12 bg-[#F6FAFB] border border-slate-100 rounded-2xl p-8 text-center">
            <h3 className="font-extrabold text-[#0A2540] text-xl">Still Have Questions?</h3>
            <p className="text-slate-600 mt-2 text-sm">
              Call us at {SITE.phone} or email {SITE.email} — we're happy to help, {SITE.hours}.
            </p>
            <div className="mt-6 flex flex-wrap justify-center gap-4">
              <a href={`tel:${SITE.phone}`}>
                <Button variant="outline" className="border-[#0A2540] text-[#0A2540] font-bold rounded-lg">
                  <Phone size={16} className="mr-2" /> {SITE.phone}
                </Button>
              </a>
              <Link to="/book">
                <Button className="bg-[#0E9AAA] hover:bg-[#0C8695] text-white font-bold rounded-lg">
                  Book a Test <ArrowRight size={16} className="ml-2" />
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
